module.exports = __webpack_public_path__ + "img/479.870651f2.png";